import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, defer, map, of, shareReplay, switchMap } from 'rxjs';

import { ENVIRONMENT } from '@environment';
import { CountrySelectionService } from '@usheru-hff/sdk/country-selection';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { Country, posGetMovieFromApi } from '@usheru-hff/shared/domain';
import { Video } from '@usheru-hff/shared/ui-video';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';

@Injectable({
  providedIn: 'root'
})
export class ChannelVideosService {
  private http = inject(HttpClient);
  private usheruApi = inject(UsheruApi);
  private translationService = inject(TranslationsService);

  private countrySelectorService = inject(CountrySelectionService);
  private readonly env = inject(ENVIRONMENT);

  private channelVideos$?: Observable<Video[]>; // Cached Observable

  private getChannelVideosApi(country?: Country, trLanguage?: string): Observable<Video[]> {
    let params = new HttpParams();
    if (trLanguage) params = params.set('trLanguage', trLanguage);
    if (country) params = params.set('country', country.id);
    return this.http
      .get<Video[]>(this.env.api.channelVideos(), {
        headers: this.usheruApi.getStandardHeader(),
        params
      })
      .pipe(
        map(videos =>
          videos.map(video => {
            if (video.movie) video.movie = posGetMovieFromApi(video.movie);
            return video;
          })
        ),
        shareReplay(1) // Caches the latest value
      );
  }

  public getChannelVideos(): Observable<Video[]> {
    if (!this.channelVideos$) {
      const trLanguage = this.translationService.currentLanguage().code;
      this.channelVideos$ = this.countrySelectorService.initialCountry$.pipe(
        switchMap(country => this.getChannelVideosApi(country, trLanguage))
      );
    }
    return this.channelVideos$;
  }
}
